import actions from './actions';
import constants from './constants';

const {
  LS_TOOLBAR_DEVELOPER_DRAWER_IS_HORIZONTAL,
} = constants;

const applyCurrentLocalStorageValues = () => (dispatch: ReduxDispatcher): void => {
  const isHorizontalLocalStorage = window.localStorage.getItem(
    LS_TOOLBAR_DEVELOPER_DRAWER_IS_HORIZONTAL,
  );
  if (isHorizontalLocalStorage !== null) {
    let isHorizontal = false;
    try {
      isHorizontal = JSON.parse(isHorizontalLocalStorage);
    } catch (error) {
      // Reset the value in local storage if it cannot be parsed properly
      window.localStorage.setItem(
        constants.LS_TOOLBAR_DEVELOPER_DRAWER_IS_HORIZONTAL,
        JSON.stringify(false),
      );
    } finally {
      dispatch(actions.setDeveloperDrawerHorizontal(isHorizontal));
    }
  }
};

const setAndStoreDeveloperDrawerHorizontal = (payload: boolean) => (
  dispatch: ReduxDispatcher,
): void => {
  dispatch(actions.setDeveloperDrawerHorizontal(payload));
  window.localStorage.setItem(
    constants.LS_TOOLBAR_DEVELOPER_DRAWER_IS_HORIZONTAL,
    JSON.stringify(payload),
  );
};

export default {
  applyCurrentLocalStorageValues,
  setAndStoreDeveloperDrawerHorizontal,
};
